// @flow
import React, {useEffect} from 'react';
import { useUserActivity } from '../HOOKS/useUserActivity';

/**
 * Component to monitor and display user activity status
 * @param {Object} props - Component props
 * @param {number} props.timeoutInMinutes - Inactivity timeout in minutes (default: 20)
 */
const UserActivityMonitor = ({timeoutInMinutes, onInactive}) => {

    const DEFAULT_TIMEOUT_IN_MINUTES = 20;
    
    useUserActivity({
        timeout: (timeoutInMinutes??DEFAULT_TIMEOUT_IN_MINUTES)*60*1000, 
        onInactive: onInactive,
        throttle: true, 
        throttleMs: 2000, 
        events: ['mousemove', 'keypress','scroll', 'touchstart', 'click']
    });
    
    useEffect( () => {
        console.log("UserActivityMonitor set to "+(timeoutInMinutes??timeoutInMinutes)+" minutes");
    }, [timeoutInMinutes]);
    
    return <></>;
};

export default UserActivityMonitor;
